<app-admin-dashboard>

    <p-card header="Carga masiva de Pre-BL">
      <p>
        Selecciona un importador y carga información de  a ordenes de programa, encuentra el formato <a [href]="uploadFormatUrl">aquí</a>.
      </p>
        <form [formGroup]="form">
                <div class="p-fluid formgrid mr-2 ml-2 grid">
                <div class="field col-6">
                    <label for="importerId" style="font-weight: bolder"
                    >{{
                      "DirectSaleFormPage.ImporterFieldLabel" | translate
                    }}
                    *</label
                  >
                  <p-dropdown
                    id="importerId"
                    formControlName="importerId"
                    [options]="importers"
                    optionValue="id"
                    optionLabel="companyName"
                    [filter]="true"
                    filterBy="companyName"
                    [showClear]="false"
                    (onChange)="onChangeImporterId()"
                    placeholder="{{
                      'DirectSaleFormPage.ImporterFieldLabel' | translate
                    }}"
                  >
                  </p-dropdown>
                </div>
            </div>
            <div class="col-6 flex justify-content-end">
              <p-button
              icon="pi pi-download"
              label="Descargar información de ordenes"
              (click)="downloadPendingOrderFormat()"
              [loading]="loadingOrderDownload"
              [disabled]="!enableDownloadOrderButton"
              >

              </p-button>
            </div>
        </form>

        <div class="col-6">
            <h3>Seleccionar archivo Excel</h3>
            <p-fileUpload name="sheetPdf[]"
                #imagesUploader
                (onSelect)="onSelect($event, imagesUploader)"
                (onRemove)="onRemove($event, imagesUploader)"
                (onClear)="onClear($event, imagesUploader)"
                [showUploadButton]="false"
                [multiple]="false"
                accept=".xlsx"
                [fileLimit]="1"
                [files]="uploadFile"
                [maxFileSize]="3000000"
                chooseLabel="Seleccionar">
                <ng-template pTemplate="toolbar">
                </ng-template>
                <ng-template pTemplate="content">
                </ng-template>
            </p-fileUpload>
            <div class="col-12 flex justify-content-end">
                <p-button label="Cargar" (onClick)="sendFiles()" [loading]="loading" [disabled]="uploadDisabled"></p-button>
            </div>
        </div>
    </p-card>

</app-admin-dashboard>

